import { distinctUntilChanged, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { Component, Inject, OnDestroy } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';

import { AuthService } from '@services/auth.service';
import { setTheme } from 'ngx-bootstrap/utils';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { 
  esLocale,
  enGbLocale,
  ukLocale,
  plLocale,
  frLocale,
  itLocale,
  deLocale,
  ptBrLocale,
  trLocale,
  viLocale,
  ruLocale
} from 'ngx-bootstrap/locale';
import { TranslateService } from '@ngx-translate/core';
import { WalletWeb3Service } from '@services/web3modal.service';


defineLocale('en-uk', enGbLocale);
defineLocale('uk', ukLocale);
defineLocale('es', esLocale);
defineLocale('pl', plLocale);
defineLocale('fr', frLocale);
defineLocale('it', itLocale);
defineLocale('de', deLocale);
defineLocale('pt', ptBrLocale);
defineLocale('tr', trLocale);
defineLocale('vi', viLocale);
defineLocale('ru', ruLocale);

export const libLang: any = {
  bootstrap: {
    en: 'en-uk',
    uk: 'uk',
    ru: 'ru',
    'es-419': 'es',
    es: 'es',
    pl: 'pl',
    fr: 'fr',
    it: 'it',
    de: 'de',
    pt: 'pt',
    tr: 'tr',
    vi: 'vi'
  },
  moment: {
    en: 'en',
    uk: 'uk',
    ru: 'ru',
    'es-419': 'es',
    es: 'es',
    pl: 'pl',
    fr: 'fr',
    it: 'it',
    de: 'de',
    pt: 'pt',
    tr: 'tr',
    vi: 'vi'
  },
};

@Component({
  selector: 'cd-app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnDestroy {
  private destroyed$ = new Subject<void>();

  tabId = Date.now().toString();

  constructor(
    public auth: AuthService,
    private router: Router,
    @Inject(DOCUMENT) private document: Document,
    private localeService: BsLocaleService,
    private translateService: TranslateService,
    public walletService: WalletWeb3Service,
  ) { 
    const urlParams = new URLSearchParams(window.location.search);
    const ref = urlParams.get('ref');

    
    if (ref) {
      localStorage.setItem('ref', ref);
      const urlWithoutQuery = window.location.origin + window.location.pathname;
      window.history.replaceState({}, document.title, urlWithoutQuery);
    }

    if (localStorage.getItem('language') === 'en-US') {
      localStorage.setItem('language', 'en');
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.setLocale = (lang = 'en') => {
      this.translateService.use(lang);
      localStorage.setItem('language', lang);
      this.localeService.use(libLang.bootstrap[lang]);
    };
    this.translateService.use(localStorage['language'] || 'en');
    this.localeService.use(libLang.bootstrap[localStorage['language'] || 'en']);
    setTheme('bs4');
    // const params = new HttpParams({ fromString: window.location.search });
    // if (params.get('id')) {
    //   localStorage.setItem('click_id', params.get('id') as string);
    // }
    // if (params.get('ga_utm_cookie')) {
    //   localStorage.setItem('ga_utm', params.get('ga_utm_cookie') as string);
    // }
    // if (params.get('clickid')) {
    //   const clickId = {
    //     clickid: params.get('clickid'),
    //     campaign: params.get('campaign'),
    //     trafficsource: params.get('trafficsource'),
    //     user_id: params.get('user_id'),
    //   };
    //   localStorage.setItem(
    //     'click_id',
    //     encodeURIComponent(btoa(JSON.stringify(clickId)))
    //   );
    // }

    if (this.auth.isLoggedIn && !this.auth.authChanged$.value) {
      this.auth.authChanged$.next(true);
    }

    this.router.events
      .pipe(
        takeUntil(this.destroyed$),
        distinctUntilChanged(),
        filter((e): e is NavigationEnd => e instanceof NavigationEnd)
      )
      .subscribe((e: NavigationEnd) => {
        // if (!this.auth.isLoggedIn) {
        //   this.router.navigate(['/']);
        // }

        if (e.url === '/') {
          document.title =  'CoinDepo DeFI-dashboard';
        } else if (e.url.includes('profile')) {
          document.title = `CoinDepo DeFI-${e.url.split('/')[2]}`;
        }  else {
          document.title = `CoinDepo DeFI-${e.url.split('/')[1]}`;
        }
      });

      this.autoLogout();
      this.updateActiveTabs();
      window.addEventListener('beforeunload', this.handleBeforeUnload.bind(this));
  }

  handleBeforeUnload() {
    sessionStorage.setItem('isReloading', 'true');
    this.autoLogout()
  }

  updateActiveTabs() {
    let activeTabs = JSON.parse(localStorage.getItem('activeTabs') as any) || {};
    activeTabs[this.tabId] = true;
    localStorage.setItem('activeTabs', JSON.stringify(activeTabs));
  }

  autoLogout() {
    const activeTabs = JSON.parse(localStorage.getItem('activeTabs') as any) || {};
    const isLoadPage = sessionStorage.getItem('isReloading') === 'true';
    delete activeTabs[this.tabId];
    localStorage.setItem('activeTabs', JSON.stringify(activeTabs));

    if (
      Object.keys(activeTabs).length === 0 &&
      !isLoadPage &&
      this.auth.isLoggedIn
    ) {
      setTimeout(() => {
        this.walletService.disconnectWallet();
      }, 1000)
    } else {
      const loader = document.getElementById('globalLoader');
      loader?.classList.add('hidden');
    }
  }
  
  ngOnDestroy(): void {    
    this.destroyed$.next();
    this.destroyed$.complete(); 
  }  
}
